import type { ReactNode } from "react";

interface AttributeReviewSourceLabelProps {
  sourceAttribute: string;
  requiredStarNode: ReactNode;
  onToggle: () => void;
}

export function AttributeReviewSourceLabel({
  sourceAttribute,
  requiredStarNode,
  onToggle,
}: AttributeReviewSourceLabelProps) {
  return (
    <div className="min-w-0" onClick={onToggle}>
      <p className="text-xs text-slate-500 dark:text-slate-400 mb-1">
        Source Attribute
      </p>
      <p className="text-sm font-medium text-slate-900 dark:text-slate-100 font-mono break-words [overflow-wrap:anywhere]">
        {sourceAttribute}
        {requiredStarNode}
      </p>
    </div>
  );
}
